<mat-dialog-content>
  <h2>
    <strong>{{ 'Groups List' | translate }}</strong>
  </h2>
  <form>
    @if (listGroups.length > 0) {
      <table class="table table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>
              <mat-label>Item</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Group' | translate }}</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Presentation' | translate }}</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Options' | translate }}</mat-label>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (group of listGroups; track group; let i = $index) {
            <tr>
              <td data-label="Item">
                {{ i + 1 }}
              </td>
              <td data-label="Group">
                {{ group.nombre }}
              </td>
              @for (presen of group.presentations; track presen) {
                <td>
                  {{ presen.value }}
                </td>
              }
              <td data-label="Options">
                <button (click)="remove(group.id_grupo, i)" mat-raised-button>
                  x
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    <br />
    @if (listGroups.length <= 0) {
      <div class="alert alert-danger">
        {{ 'NO RECORDS FOUND' | translate }}
      </div>
    }
    <br />
    <form [formGroup]="registerForm">
      <table class="table table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>
              <mat-label>{{ 'Add Group' | translate }}</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Select Presentation' | translate }}</mat-label>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Add Group">
              <input
                style="width: 200px"
                class="form-control"
                type="text"
                formControlName="group"
              />
              @if (textValid('group')) {
                <span class="form-text text-danger">{{
                  'Group invalid' | translate
                }}</span>
              }
            </td>
            <td data-label="Select Presentation">
              <select class="form-control" formControlName="presentation">
                @for (presen of listPresentations; track presen) {
                  <option [ngValue]="presen.id_type">{{ presen.value }}</option>
                }
              </select>
              @if (textValid('presentation')) {
                <span class="form-text text-danger">{{
                  'Presentation invalid' | translate
                }}</span>
              }
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <button
        mat-raised-button
        (click)="update()"
        style="margin-left: 20px; margin-bottom: 20px"
      >
        {{ 'Add' | translate }}
      </button>
      <button
        mat-raised-button
        mat-dialog-close
        style="margin-left: 20px; margin-bottom: 20px"
      >
        {{ 'Close' | translate }}
      </button>
    </form>
  </form>
</mat-dialog-content>
